module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "buy-car d-flex wrap mb-2"
  }, [_c('div', {
    staticClass: " d-flex flex-65 wrap"
  }, [(_vm.hideComponents) ? _c('component-sale', {
    attrs: {
      "quantity": _vm.quantityResume
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPayment) ? _c('div', {
    staticClass: "d-flex mb-4 mt-4 section-title-container wrap txt-center align-center"
  }, [_c('products-buy-car-svg'), _vm._v(" "), _c('h2', {
    staticClass: "uppercase bold section-title",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v("Productos")])], 1) : _vm._e(), _vm._v(" "), _c('buy-table', {
    staticClass: "buy-table flex-95"
  }), _vm._v(" "), _c('router-view', {
    staticClass: "flex-95"
  })], 1), _vm._v(" "), _c('purchase-summary', {
    staticClass: "flex-15",
    on: {
      "go-back": _vm.back
    }
  })], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09976a63","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BuyCar.vue
// module id = 1068
// module chunks = 14